import { toast } from "react-hot-toast";

import { ApiService, LISCaseWithWork } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

type GetArgs = Parameters<typeof ApiService.caseWithWorkSlide>[0];
export const getCaseForSlide = createAsyncSaga(
  LIS.SLIDE.GET_CASE.REQUEST,
  LIS.SLIDE.GET_CASE.SUCCESS,
  LIS.SLIDE.GET_CASE.ERROR,
  ({ id }) => `lis/slides/${id}/case`,
  (args: GetArgs) => ApiService.caseWithWorkSlide(args)
) as AsyncSagaAction<GetArgs>;

type ScanSlideArgs = Parameters<typeof ApiService.scanSlide>[0];
export const scanSlide = createAsyncSaga(
  LIS.SLIDE.SCAN.REQUEST,
  LIS.SLIDE.SCAN.SUCCESS,
  LIS.SLIDE.SCAN.ERROR,
  ({ id }) => `lis/slides/${id}/scan`,
  (args: ScanSlideArgs) => {
    const tid = toast.loading("Scanned Slide");
    return ApiService.scanSlide(args)
      .then((response: LISCaseWithWork) => {
        toast.success("Scanned Slide", { id: tid });
        return response;
      })
      .catch((error) => {
        toast.error(`Scanned Slide\n${error.message}`, { id: tid });
      });
  }
) as AsyncSagaAction<ScanSlideArgs>;

export const printAdditionalSlide = createAsyncSaga(
  LIS.SLIDE.PRINT_ADDITIONAL.REQUEST,
  LIS.SLIDE.PRINT_ADDITIONAL.SUCCESS,
  LIS.SLIDE.PRINT_ADDITIONAL.ERROR,
  ({ id }) => `lis/slides/${id}/print_additional`,
  ApiService.printAdditionalSlide
) as AsyncSagaAction<Parameters<typeof ApiService.printAdditionalSlide>[0]>;
